import { render, staticRenderFns } from "./RedeemCredits.vue?vue&type=template&id=f159e1cc&"
import script from "./RedeemCredits.vue?vue&type=script&lang=js&"
export * from "./RedeemCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports